import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";

@Injectable()
export class MediaServiceService {
  constructor(private afd: AngularFireDatabase) {}

  getBtnStatus() {
    let btnStatus = this.afd.object("gallery/btn");
    return btnStatus;
  }
  getImages(race: string) {
    let raceImages = this.afd.object("gallery/" + race);
    return raceImages;
  }
  getCircuitDetails(race: string) {
    let circuitDetails = this.afd.object("details/" + race);
    return circuitDetails;
  }

  getRaceDate(race: string, year: string) {
    return this.afd.object("calendar/" + year + "/" + race);
  }

  getImagesYear(race: string, year: string) {
    const raceImgYear = this.afd.object("gallery/" + year + "/" + race);
    return raceImgYear;
  }

  getBtnStatusYear(year: string) {
    const res = this.afd.object(`gallery/${year}/statuses`);
    return this.afd.object(`gallery/${year}/statuses`);
  }
}



// WEBPACK FOOTER //
// ./src/app/media/media-service.service.ts